<div class="auth-container">
  <div class="auth-background">
    <div class="background-pattern"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <div class="auth-header">
        <div class="app-logo">
          <img
            class="logo-img"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="app-title">ReBall</h1>
        </div>

        @if (!emailSent) {
        <h2 class="auth-title">Forgot Password?</h2>
        <p class="auth-subtitle">
          Enter your email address and we'll send you instructions to reset your
          password
        </p>
        } @else {
        <h2 class="auth-title">Check Your Email</h2>
        <p class="auth-subtitle">
          We've sent password reset instructions to your email address
        </p>
        }
      </div>

      @if (!emailSent) {
      <form
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="onSubmit()"
        class="auth-form"
      >
        <div class="form-group">
          <label class="form-label" for="email">Email Address</label>
          <div class="input-wrapper">
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-input"
              [class.error]="submitted && f['email']?.errors"
              placeholder="Enter your email address"
            />
            <div class="input-icon">
              <lucide-icon name="mail" [size]="18"></lucide-icon>
            </div>
          </div>
          <div *ngIf="submitted && f['email']?.errors" class="error-message">
            <div *ngIf="f['email']?.errors?.['required']">
              Email is required
            </div>
            <div *ngIf="f['email']?.errors?.['email']">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="loading"
          class="auth-button primary"
          [class.loading]="loading"
        >
          <div class="button-content">
            <div class="button-spinner" *ngIf="loading"></div>
            <span class="button-text">{{
              loading ? "Sending..." : "Send Reset Instructions"
            }}</span>
          </div>
        </button>

        <div class="auth-divider">
          <span>Remember your password?</span>
        </div>

        <button type="button" routerLink="/login" class="auth-button secondary">
          Back to Sign In
        </button>
      </form>
      } @else {
      <div class="success-content">
        <div class="success-icon">
          <lucide-icon
            name="circle-check"
            [size]="48"
            color="#10b981"
          ></lucide-icon>
        </div>
        <div class="success-message">
          <h3>Instructions Sent!</h3>
          <p>
            Check your email inbox and follow the instructions to reset your
            password.
          </p>
        </div>

        <div class="success-actions">
          <button
            type="button"
            (click)="goBackToLogin()"
            class="auth-button primary"
          >
            Back to Sign In
          </button>

          <button
            type="button"
            (click)="resendEmail()"
            class="auth-button secondary"
          >
            Didn't receive email? Try again
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>
